export default (siteName) => [
    {
        path: 'tax-credit-invoice',
        name: 'tax-credit-invoice',
        component: () => import('../../components/dashboard/Finance/TaxCreditInvoice/IndexPage.vue'),
        meta: {
            title: `外部進項發票${siteName}`,
            activeMenu: 'declaration',
        },
    },
    {
        path: 'tax-credit-invoice/add',
        name: 'tax-credit-invoice-add',
        component: () => import('../../components/dashboard/Finance/TaxCreditInvoice/EditPage.vue'),
        meta: {
            title: `新增外部進項發票${siteName}`,
            activeMenu: 'declaration',
        },
    },
    {
        path: 'tax-credit-invoice/:sno/edit',
        name: 'tax-credit-invoice-edit',
        component: () => import('../../components/dashboard/Finance/TaxCreditInvoice/EditPage.vue'),
        meta: {
            title: `修改外部進項發票${siteName}`,
            activeMenu: 'declaration',
        },
    },
];
